export const currencies: { value: string; label: string }[] = [
  {
    value: "USD",
    label: "$",
  },
  {
    value: "EUR",
    label: "€",
  },
  {
    value: "PLN",
    label: "zł",
  },
  {
    value: "RUB",
    label: "₽",
  },
  {
    value: "TRY",
    label: "₺",
  },
  {
    value: "KZT",
    label: "₸",
  },
];

export const language = ["RU", "EN"];

export const OPERATOR_ID = "40077";

export const IS_MOBILE =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

export const TABLE_HISTORY_FILTER = [
  {
    id: 1,
    type: {
      value: "currency",
      display_value: "Валюта",
    },
    values: [
      { value: "USD", display_value: "USD" },
      { value: "RUB", display_value: "RUB" },
      { value: "EUR", display_value: "EUR" },
    ],
  },
  {
    id: 2,
    type: {
      value: "status",
      display_value: "Статус",
    },
    values: [
      { value: "success", display_value: "Доставлен" },
      { value: "error", display_value: "Ошибка" },
      { value: "pending", display_value: "Ожидание" },
    ],
  },
  {
    id: 3,
    type: {
      value: "transaction",
      display_value: "Транзакция",
    },
    values: [
      { value: "withdrawals", display_value: "Вывод" },
      { value: "refill", display_value: "Депозит" },
    ],
  },
];

export const BANK_METHODS = {
  EKORPAY: {
    dev: ["41", "15"],
    prod: ["29"],
  },
  REPAY: {
    dev: ["22"],
    prod: ["40"],
  },
  INWIZORUB: {
    dev: ["33"],
    prod: ["83"],
  },
  INWIZOTRY: {
    dev: ["0"],
    prod: ["97"],
  },
  FAIRPAY_TRY: {
    dev: ["43"],
    prod: ["98"],
  },
};

export const repayBanks = [
  {
    bankName: "Банк АВАНГАРД",
    schema: "b9a2a338-ccd7-4bb1-8bf3-e7b626f9ac37",
    logoURL: "",
  },
  {
    bankName: "Банк Элита",
    schema: "d70ffacd-2020-4d27-851a-a823573038de",
    logoURL: "",
  },
  {
    bankName: "Банк ФК Открытие",
    schema: "b028103a-7dc9-4c60-bb2b-dcee8656b65e",
    logoURL: "",
  },
  {
    bankName: "ВТБ",
    schema: "e93488d9-d2c9-404b-85f9-b37eb35a2f99",
    logoURL: "",
  },
  {
    bankName: "СберБанк",
    schema: "a28333c4-db42-4805-b560-4db95ad50dca",
    logoURL: "",
  },
  {
    bankName: "МКБ (Московский кредитный банк)",
    schema: "6ad58e62-1f44-4f40-8843-e7359e988db7",
    logoURL: "",
  },
  {
    bankName: "Совкомбанк",
    schema: "9bcc36cb-09a1-478b-9c9d-0758aa8b806c",
    logoURL: "",
  },
  {
    bankName: "Т-Банк (Тинькофф)",
    schema: "19235c82-622e-4286-888f-2ecd25c0b009",
    logoURL: "",
  },
  {
    bankName: "Россельхозбанк",
    schema: "62381f29-0776-48c2-90ee-d7d68fe371ec",
    logoURL: "",
  },
  {
    bankName: "ЮниКредит Банк",
    schema: "32ce7bfa-f0e2-4f04-9731-31a39bcd8c0c",
    logoURL: "",
  },
  {
    bankName: "Райффайзен Банк",
    schema: "f2d25a0d-65bc-4dbe-9e98-6c3015bbd90a",
    logoURL: "",
  },
  {
    bankName: "Промсвязьбанк",
    schema: "e5cce7cb-665a-4aa3-8240-2002694869ee",
    logoURL: "",
  },
  {
    bankName: "Росбанк",
    schema: "504d81e3-55d5-4313-bf45-5eae52879150",
    logoURL: "",
  },
  {
    bankName: "Газпромбанк",
    schema: "0634762b-63a2-4b85-8e79-9d12a61874aa",
    logoURL: "",
  },
  {
    bankName: "Альфа Банк",
    schema: "691103fb-7351-4480-8a6d-03a91f1a54b5",
    logoURL: "",
  },
  {
    bankName: "Озон Банк (Ozon)",
    schema: "84a3cc4e-f94f-4081-ac5c-92420fb3e836",
    logoURL: "",
  },
  {
    bankName: "Ак Барс Банк",
    schema: "10831233-07ff-461f-9cb2-414e3a003786",
    logoURL: "",
  },
  {
    bankName: "Хоум Кредит Банк (Хоум Банк)",
    schema: "ef10f896-5d53-47b0-bbf6-5b0f8f92027e",
    logoURL: "",
  },
  {
    bankName: "МТС Банк",
    schema: "b3d8508e-82bb-4fb7-96c6-8dca6bee3c41",
    logoURL: "",
  },
  {
    bankName: "УБРиР",
    schema: "2a539b2c-b054-4c1c-95c0-ae5b098c0895",
    logoURL: "",
  },
  {
    bankName: "Яндекс Банк",
    schema: "314b2f17-b03e-4eba-9c00-e5cab25c31db",
    logoURL: "",
  },
  {
    bankName: "РНКБ Банк",
    schema: "b585dad8-a503-4b5e-a1c8-b981763accf3",
    logoURL: "",
  },
  {
    bankName: "Почта Банк",
    schema: "60fe6929-a0ac-4d2a-84d3-1f1324e871d1",
    logoURL: "",
  },
  {
    bankName: "Точка Банк",
    schema: "85445625-c9df-4d32-8c49-f84ee3e256c2",
    logoURL: "",
  },
];

export const fairpayTRYBanks = [
  { bankName: "Adabank", schema: "adabank", logoURL: "" },
  { bankName: "Akbank", schema: "akbank", logoURL: "" },
  { bankName: "Aktif Yatırım Bankası", schema: "aktif_yatirim", logoURL: "" },
  {
    bankName: "Albaraka Türk Katılım Bankası",
    schema: "albaraka_turk_katilim",
    logoURL: "",
  },
  { bankName: "Alternatif Bank", schema: "alternatif", logoURL: "" },
  { bankName: "Anadolubank", schema: "anadolubank", logoURL: "" },
  { bankName: "Asya Katılım Bankası", schema: "asya_katilim", logoURL: "" },
  { bankName: "Burgan Bank", schema: "burgan", logoURL: "" },
  { bankName: "Citibank", schema: "city", logoURL: "" },
  { bankName: "DenizBank", schema: "denizbank", logoURL: "" },
  { bankName: "Enpara.com (QNB Finansbank)", schema: "enpara", logoURL: "" },
  { bankName: "FAST", schema: "fast", logoURL: "" },
  { bankName: "Fibabanka", schema: "fiba", logoURL: "" },
  { bankName: "Garanti BBVA", schema: "garanti", logoURL: "" },
  { bankName: "Halkbank", schema: "halk_bank", logoURL: "" },
  { bankName: "HSBC Türkiye", schema: "hsbc", logoURL: "" },
  { bankName: "ING Bank Türkiye", schema: "ing_bank", logoURL: "" },
  { bankName: "Türkiye İş Bankası", schema: "is_bank", logoURL: "" },
  {
    bankName: "Kuveyt Türk (Evkaf Finans Kurumu)",
    schema: "kuveyt_turk_evkaf_finans_kurumu",
    logoURL: "",
  },
  {
    bankName: "Kuveyt Türk Katılım Bankası",
    schema: "kuveyt_turk_katilim_bankasi",
    logoURL: "",
  },
  { bankName: "Odeabank", schema: "odea", logoURL: "" },
  { bankName: "PTT Bank", schema: "ptt_bank", logoURL: "" },
  { bankName: "QNB Finansbank", schema: "qnb_finans_bank", logoURL: "" },
  { bankName: "Şekerbank", schema: "sekerbank", logoURL: "" },
  {
    bankName: "Türk Ekonomi Bankası (TEB)",
    schema: "turk_ekonomi",
    logoURL: "",
  },
  {
    bankName: "Türkiye Emlak Katılım Bankası",
    schema: "turkiye_emlak_katilim",
    logoURL: "",
  },
  {
    bankName: "Türkiye Finans Katılım Bankası",
    schema: "turkiye_finans_katilim",
    logoURL: "",
  },
  { bankName: "VakıfBank", schema: "vakifbank", logoURL: "" },
  { bankName: "Vakıf Katılım Bankası", schema: "vakif_katilim", logoURL: "" },
  { bankName: "Yapı ve Kredi Bankası", schema: "yapi_ve_kredi", logoURL: "" },
  { bankName: "Ziraat Bankası", schema: "ziraatbank", logoURL: "" },
  { bankName: "Ziraat Katılım Bankası", schema: "ziraat_katilim", logoURL: "" },
];

export const inwizoBanks = [
  {
    bankName: "Сбербанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000111.png",
    schema: "bank100000000111",
    package_name: "ru.sberbankmobile",
    isDrActive: true,
  },
  {
    bankName: "Т-Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000004.png",
    schema: "bank100000000004",
    package_name: "com.idamob.tinkoff.android",
    webClientUrl: "https://www.tinkoff.ru/mybank/payments/qr-pay",
    isWebClientActive: "true",
  },
  {
    bankName: "Банк ВТБ",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000005.png",
    schema: "bank110000000005",
    package_name: "ru.vtb24.mobilebanking.android",
    webClientUrl: "https://online.vtb.ru/i/paymentSbp",
    isWebClientActive: "true",
    isDrActive: true,
  },
  {
    bankName: "АЛЬФА-БАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000008.png",
    schema: "bank100000000008",
    package_name: "ru.alfabank.mobile.android",
    webClientUrl: "https://alfa-mobile.alfabank.ru/mobile-public/goto/qr",
    isWebClientActive: "true",
    isDrActive: false,
  },
  {
    bankName: "Райффайзенбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000007.png",
    schema: "bank100000000007",
    package_name: "ru.raiffeisennews",
    webClientUrl: "https://online.raiffeisen.ru/outer/qr/qr.nspk.ru",
    isWebClientActive: "true",
  },
  {
    bankName: "Газпромбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000001.png",
    schema: "bank100000000001",
    package_name: "ru.gazprombank.android.mobilebank.app",
    webClientUrl: "https://sbpgpb.ru/c2bpayments",
    isWebClientActive: "true",
    isDrActive: true,
  },
  {
    bankName: "Банк ПСБ",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000010.png",
    schema: "bank100000000010",
    package_name: "logo.com.mbanking",
    webClientUrl: "https://ib.psbank.ru/sbp/payment",
    isWebClientActive: "true",
    isDrActive: false,
  },
  {
    bankName: "Совкомбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000013.png",
    schema: "bank100000000013",
    package_name: "ru.sovcomcard.halva.v1",
    webClientUrl: "https://halvacard.ru/lk/qr",
    isWebClientActive: "true",
    isDrActive: false,
  },
  {
    bankName: "Россельхозбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000020.png",
    schema: "bank100000000020",
    package_name: "ru.rshb.dbo",
  },
  {
    bankName: "МОСКОВСКИЙ КРЕДИТНЫЙ БАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000025.png",
    schema: "bank100000000025",
    package_name: "ru.mkb.mobile",
  },
  {
    bankName: "ЮниКредит Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000030.png",
    schema: "bank100000000030",
    package_name: "ru.unicredit.android",
    webClientUrl: "https://enter.unicredit.ru/c2b",
    isWebClientActive: "true",
  },
  {
    bankName: "Банк Синара",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000003.png",
    schema: "bank100000000003",
    package_name: "ru.skbbank.ib",
    isDrActive: true,
  },
  {
    bankName: "Газэнергобанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000043.png",
    schema: "bank100000000043",
    package_name: "ru.gebank.ib",
  },
  {
    bankName: "АКБ АВАНГАРД",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000028.png",
    schema: "bank100000000028",
    package_name: "ru.avangard.sbp_client",
  },
  {
    bankName: "ПНКО ЭЛПЛАТ",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000086.png",
    schema: "bank100000000086",
    package_name: "ru.elplat.elplat2",
  },
  {
    bankName: "РНКБ Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000011.png",
    schema: "bank100000000011",
    package_name: "com.bifit.rncbbeta",
  },
  {
    bankName: "Экспобанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000044.png",
    schema: "bank100000000044",
    package_name: "ru.ftc.faktura.expobank",
    webClientUrl: "https://online.expobank.ru/fps/c2b",
    isWebClientActive: "true",
  },
  {
    bankName: "Банк ВБРР",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000049.png",
    schema: "bank100000000049",
    package_name: "com.bssys.vbrrretail",
    webClientUrl: "https://online.vbrr.ru/#/external/fps",
    isWebClientActive: "true",
  },
  {
    bankName: "АБ РОССИЯ",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000095.png",
    schema: "bank100000000095",
    package_name: "ru.artsofte.russiafl",
    webClientUrl: "https://i2.abr.ru/c2b/qr",
    isWebClientActive: "true",
  },
  {
    bankName: "ДБО Фактура",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000900.png",
    schema: "bank100000000900",
    package_name: "ru.ftc.faktura.multibank",
  },
  {
    bankName: "КБ Хлынов",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000056.png",
    schema: "bank100000000056",
    package_name: "ru.bank_hlynov.xbank",
    webClientUrl: "https://my.bank-hlynov.ru/sbp/qr",
    isWebClientActive: "true",
  },
  {
    bankName: "Бланк банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000053.png",
    schema: "bank100000000053",
    package_name: "ru.ftc.faktura.vesta",
  },
  {
    bankName: "КБ Солидарность",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000121.png",
    schema: "bank100000000121",
    package_name: "com.isimplelab.ibank.solidarnost",
  },
  {
    bankName: "Банк ДОМ.РФ",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000082.png",
    schema: "bank100000000082",
    package_name: "com.bssys.roscapretail",
    webClientUrl: "https://my.domrfbank.ru/app/sbp/c2b",
    isWebClientActive: "true",
    isDrActive: true,
  },
  {
    bankName: "Хакасский муниципальный банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000127.png",
    schema: "bank100000000127",
    package_name: "ru.ftc.faktura.kbhmb",
  },
  {
    bankName: "МТС-Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000017.png",
    schema: "bank100000000017",
    package_name: "ru.mts.money",
    isDrActive: true,
  },
  {
    bankName: "Банк ПСКБ",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000087.png",
    schema: "bank100000000087",
    package_name: "ru.ftc.faktura.pskb",
    webClientUrl: "https://dbo.pscb.ru/fps/c2b/",
    isWebClientActive: "true",
  },
  {
    bankName: "Банк Левобережный",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000052.png",
    schema: "bank100000000052",
    package_name: "ru.ftc.faktura.nskbl",
    webClientUrl: "https://bl-online.nskbl.ru/fps/c2b",
    isWebClientActive: "true",
  },
  {
    bankName: "АК БАРС БАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000006.png",
    schema: "bank100000000006",
    package_name: "ru.akbars.mobile",
    isDrActive: true,
  },
  {
    bankName: "КБ РостФинанс",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000098.png",
    schema: "bank100000000098",
    package_name: "ru.ftc.faktura.rostfinance",
    webClientUrl: "https://online.rostfinance.ru/petition/c2b_sbp/qr",
    isWebClientActive: "true",
  },
  {
    bankName: "БыстроБанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000092.png",
    schema: "bank100000000092",
    webClientUrl: "https://www.bystrobank.ru/sbp/c2b/",
    isWebClientActive: "true",
  },
  {
    bankName: "МС Банк Рус",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000229.png",
    schema: "bank100000000229",
    package_name: "ru.mcbankrus.MCBankRus",
  },
  {
    bankName: "Кредит Европа Банк (Россия)",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000027.png",
    schema: "bank100000000027",
  },
  {
    bankName: "АКБ Алмазэргиэнбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000080.png",
    schema: "bank100000000080",
    package_name: "ru.albank.online.aebit",
  },
  {
    bankName: "ИК Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000122.png",
    schema: "bank100000000122",
    package_name: "com.bifit.mobile.citizen.icbru",
  },
  {
    bankName: "БАНК ОРЕНБУРГ",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000124.png",
    schema: "bank100000000124",
    package_name: "ru.ftc.faktura.orbank",
  },
  {
    bankName: "КБ АГРОПРОМКРЕДИТ",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000118.png",
    schema: "bank100000000118",
    package_name: "ru.ftc.faktura.agropromkredit",
  },
  {
    bankName: "АКБ Энергобанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000159.png",
    schema: "bank100000000159",
    package_name: "com.energobank.digital",
  },
  {
    bankName: "КОШЕЛЕВ-БАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000146.png",
    schema: "bank100000000146",
    package_name: "com.bifit.mobile.citizen.kbnk",
  },
  {
    bankName: "СДМ-Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000069.png",
    schema: "bank100000000069",
    package_name: "ru.ftc.faktura.sdm",
    webClientUrl: "https://online.sdm.ru/fps/c2b",
    isWebClientActive: "true",
  },
  {
    bankName: "МБ Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000140.png",
    schema: "bank100000000140",
    package_name: "com.bifit.mobile.citizen.mbb",
  },
  {
    bankName: "АКБ Абсолют Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000047.png",
    schema: "bank100000000047",
    package_name: "ru.ftc.faktura.absolutbank",
  },
  {
    bankName: "КБ Модульбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000099.png",
    schema: "bank100000000099",
    package_name: "ru.ftc.faktura.multibank",
  },
  {
    bankName: "Банк Акцепт",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000135.png",
    schema: "bank100000000135",
    package_name: "ru.ftc.faktura.akcept",
    webClientUrl: "https://dbo.akcept.ru/fps/c2b",
    isWebClientActive: "true",
  },
  {
    bankName: "КБ ЭНЕРГОТРАНСБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000139.png",
    schema: "bank100000000139",
    package_name: "ru.ftc.faktura.etbank",
  },
  {
    bankName: "СИБСОЦБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000166.png",
    schema: "bank100000000166",
    package_name: "ru.ftc.faktura.multibank",
  },
  {
    bankName: "Банк Развитие-Столица",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000172.png",
    schema: "bank100000000172",
    package_name: "ru.ftc.faktura.razvitiestolica",
  },
  {
    bankName: "Банк РЕСО Кредит",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000187.png",
    schema: "bank100000000187",
    package_name: "ru.ftc.faktura.resokreditbank",
  },
  {
    bankName: "НКО ЮМани",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000022.png",
    schema: "bank100000000022",
    package_name: "ru.yoo.money",
  },
  {
    bankName: "Банк Санкт-Петербург",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000029.png",
    schema: "bank100000000029",
    package_name: "ru.bspb",
  },
  {
    bankName: "КБ Кубань Кредит",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000050.png",
    schema: "bank100000000050",
    package_name: "com.isimplelab.ibank.kubankredit",
  },
  {
    bankName: "Банк НОВИКОМ (НОВИКОМБАНК)",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000177.png",
    schema: "bank100000000177",
    package_name: "com.bssys.novikomretail",
  },
  {
    bankName: "РосДорБанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000084.png",
    schema: "bank100000000084",
    package_name: "ru.rosdorbank.physical",
  },
  {
    bankName: "СКБ Приморья Примсоцбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000088.png",
    schema: "bank100000000088",
    package_name: "ru.ftc.faktura.primsoc",
  },
  {
    bankName: "Банк Саратов",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000126.png",
    schema: "bank100000000126",
    package_name: "ru.ftc.faktura.banksaratov",
  },
  {
    bankName: "Таврический Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000173.png",
    schema: "bank100000000173",
    package_name: "ru.ftc.faktura.tavrich",
  },
  {
    bankName: "Тольяттихимбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000152.png",
    schema: "bank100000000152",
    package_name: "com.bifit.mobile.citizen.thbank",
  },
  {
    bankName: "Банк Кремлевский",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000201.png",
    schema: "bank100000000201",
    package_name: "ru.ftc.faktura.kremlevskiy",
  },
  {
    bankName: "ТКБ БАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000034.png",
    schema: "bank100000000034",
    package_name: "ru.ftc.faktura.tkbbank",
    isDrActive: false,
  },
  {
    bankName: "ЧЕЛЯБИНВЕСТБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000094.png",
    schema: "bank100000000094",
    package_name: "ru.chelyabinvestbank.investpay",
  },
  {
    bankName: "АКБ Держава",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000235.png",
    schema: "bank100000000235",
    package_name: "ru.ftc.faktura.derzhava",
  },
  {
    bankName: "НБД-Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000134.png",
    schema: "bank100000000134",
    package_name: "ru.nbd.android",
  },
  {
    bankName: "БАНК СНГБ",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000091.png",
    schema: "bank100000000091",
    package_name: "ru.sngb.dbo.client.android",
  },
  {
    bankName: "АИКБ Енисейский объединенный банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000258.png",
    schema: "bank100000000258",
    package_name: "ru.ftc.faktura.united",
  },
  {
    bankName: "Банк Венец",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000153.png",
    schema: "bank100000000153",
    package_name: "ru.ftc.faktura.venetsbank",
  },
  {
    bankName: "Почта Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000016.png",
    schema: "bank100000000016",
    package_name: "ru.letobank.Prometheus",
  },
  {
    bankName: "Банк Русский Стандарт",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000014.png",
    schema: "bank100000000014",
    package_name: "ru.simpls.brs2.mobbank",
  },
  {
    bankName: "Дальневосточный банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000083.png",
    schema: "bank100000000083",
    package_name: "com.bifit.dvbank",
  },
  {
    bankName: "Банк Интеза",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000170.png",
    schema: "bank100000000170",
    package_name: "ru.ftc.faktura.intesabank",
  },
  {
    bankName: "ГЕНБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000037.png",
    schema: "bank100000000037",
    package_name: "com.mmonline.mobile",
  },
  {
    bankName: "ВУЗ-банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000215.png",
    schema: "bank100000000215",
    package_name: "cb.ibank.vuz",
  },
  {
    bankName: "УРАЛПРОМБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000142.png",
    schema: "bank100000000142",
    package_name: "ru.uralprombank.mobilebanknew.googleplay",
  },
  {
    bankName: "Банк Национальный стандарт",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000243.png",
    schema: "bank100000000243",
    package_name: "ru.ftc.faktura.nsbank",
  },
  {
    bankName: "Банк Екатеринбург",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000090.png",
    schema: "bank100000000090",
    package_name: "ru.emb.android",
  },
  {
    bankName: "МОРСКОЙ БАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000171.png",
    schema: "bank100000000171",
    package_name: "ru.ftc.faktura.maritimebank",
  },
  {
    bankName: "Кредит Урал Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000064.png",
    schema: "bank100000000064",
    package_name: "com.credituralbank.CUBmobilenew",
    webClientUrl: "https://direct.creditural.ru/mobile/",
    isWebClientActive: "true",
  },
  {
    bankName: "Углеметбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000093.png",
    schema: "bank100000000093",
    package_name: "com.isimplelab.isimpleceo.uglemet",
  },
  {
    bankName: "Авто Финанс Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000253.png",
    schema: "bank100000000253",
    package_name: "ru.ftc.faktura.multibank",
  },
  {
    bankName: "КБ СТРОЙЛЕСБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000193.png",
    schema: "bank100000000193",
    package_name: "com.bssys.stroylesretail",
  },
  {
    bankName: "Банк ИТУРУП",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000158.png",
    schema: "bank100000000158",
    package_name: "ru.ftc.faktura.iturup",
  },
  {
    bankName: "Первый Инвестиционный Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000174.png",
    schema: "bank100000000174",
    package_name: "ru.ftc.faktura.finbank",
  },
  {
    bankName: "Газтрансбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000183.png",
    schema: "bank100000000183",
    package_name: "ru.ftc.faktura.gaztransbank",
  },
  {
    bankName: "ЧЕЛИНДБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000106.png",
    schema: "bank100000000106",
    package_name: "com.isimplelab.ibank.chelind",
  },
  {
    bankName: "НИКО-БАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000115.png",
    schema: "bank100000000115",
    package_name: "ru.ftc.faktura.multibank",
  },
  {
    bankName: "НОКССБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000062.png",
    schema: "bank100000000062",
    package_name: "ru.ftc.faktura.nokss",
  },
  {
    bankName: "ВЛАДБИЗНЕСБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000058.png",
    schema: "bank100000000058",
    package_name: "ru.ftc.faktura.vlbb",
  },
  {
    bankName: "Кузнецкбизнесбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000195.png",
    schema: "bank100000000195",
    package_name: "ru.ftc.faktura.kbb",
  },
  {
    bankName: "Томскпромстройбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000206.png",
    schema: "bank100000000206",
    package_name: "ru.ftc.faktura.multibank",
  },
  {
    bankName: "АКБ МЕЖДУНАРОДНЫЙ ФИНАНСОВЫЙ КЛУБ",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000203.png",
    schema: "bank100000000203",
    package_name: "ru.ftc.faktura.mfkbank",
  },
  {
    bankName: "АКБ Форштадт",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000081.png",
    schema: "bank100000000081",
    package_name: "ru.ftc.faktura.forshtadt",
  },
  {
    bankName: "АКБ Солид",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000230.png",
    schema: "bank100000000230",
    package_name: "ru.ftc.faktura.solidbank",
  },
  {
    bankName: "Банк АЛЕКСАНДРОВСКИЙ",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000211.png",
    schema: "bank100000000211",
    package_name: "ru.ftc.faktura.alexbank",
  },
  {
    bankName: "АКИБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000107.png",
    schema: "bank100000000107",
    package_name: "ru.ftc.faktura.akibank",
  },
  {
    bankName: "Нацинвестпромбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000185.png",
    schema: "bank100000000185",
    package_name: "ru.ftc.faktura.nipbank",
  },
  {
    bankName: "АКБ Алеф-Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000113.png",
    schema: "bank100000000113",
    package_name: "ru.ftc.faktura.alefbank",
  },
  {
    bankName: "КБ ВНЕШФИНБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000248.png",
    schema: "bank100000000248",
    package_name: "com.bifit.vfbank",
  },
  {
    bankName: "КБ Урал ФД",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000151.png",
    schema: "bank100000000151",
    package_name: "com.bssys.uralfdretail",
  },
  {
    bankName: "КБ АРЕСБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000129.png",
    schema: "bank100000000129",
    package_name: "ru.ftc.faktura.multibank",
  },
  {
    bankName: "Северный Народный Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000208.png",
    schema: "bank100000000208",
    package_name: "com.snb.online",
  },
  {
    bankName: "Банк Объединенный капитал",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000182.png",
    schema: "bank100000000182",
    package_name: "com.bifit.mobile.citizen.okbank",
  },
  {
    bankName: "ТАТСОЦБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000189.png",
    schema: "bank100000000189",
    package_name: "com.tatsotsbank.dbomobile",
  },
  {
    bankName: "Норвик Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000202.png",
    schema: "bank100000000202",
    package_name: "ru.vtkbank.android",
  },
  {
    bankName: "НС Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000071.png",
    schema: "bank100000000071",
    package_name: "ru.ftc.faktura.ns",
  },
  {
    bankName: "Земский банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000066.png",
    schema: "bank100000000066",
    package_name: "ru.ftc.faktura.zemskybank",
  },
  {
    bankName: "Банк Аверс",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000154.png",
    schema: "bank100000000154",
    package_name: "com.bssys.aversretail",
  },
  {
    bankName: "КБ РУСНАРБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000194.png",
    schema: "bank100000000194",
    package_name: "ru.rusnarbank.correqts.retail",
    webClientUrl: "https://online.rusnarbank.ru/#/external/fps",
    isWebClientActive: "true",
  },
  {
    bankName: "РЕАЛИСТ БАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000232.png",
    schema: "bank100000000232",
    package_name: "ru.ftc.faktura.baikalinvestbank",
  },
  {
    bankName: "Эс-Би-Ай Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000105.png",
    schema: "bank100000000105",
    package_name: "ru.sbi.android",
  },
  {
    bankName: "МЕТКОМБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000136.png",
    schema: "bank100000000136",
    package_name: "com.metkombank.mobile",
  },
  {
    bankName: "КБЭР Банк Казани",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000191.png",
    schema: "bank100000000191",
    package_name: "com.isimplelab.ionic.kazan.fl",
  },
  {
    bankName: "АКБ Трансстройбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000197.png",
    schema: "bank100000000197",
    package_name: "com.intervale.sbp.atlas",
  },
  {
    bankName: "Банк Заречье",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000205.png",
    schema: "bank100000000205",
    package_name: "com.bifit.mobile.citizen.zarech",
  },
  {
    bankName: "КБ Центр-инвест",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000059.png",
    schema: "bank100000000059",
    package_name: "ru.centrinvest.mobilebanking2018",
  },
  {
    bankName: "Датабанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000070.png",
    schema: "bank100000000070",
    package_name: "com.mifors.izhcombank",
  },
  {
    bankName: "СОЦИУМ-БАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000223.png",
    schema: "bank100000000223",
    package_name: "com.intervale.sbp.atlas",
  },
  {
    bankName: "КБ СИНКО-БАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000148.png",
    schema: "bank100000000148",
    package_name: "com.intervale.sbp.atlas",
  },
  {
    bankName: "ИШБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000199.png",
    schema: "bank100000000199",
    package_name: "com.bifit.pmobile.isbank",
  },
  {
    bankName: "Банк ЗЕНИТ",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000045.png",
    schema: "bank100000000045",
    package_name: "ru.zenit.android",
    webClientUrl: "https://i.zenit.ru/sbpPay",
    isWebClientActive: "true",
  },
  {
    bankName: "АКБ ФОРА-БАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000217.png",
    schema: "bank100000000217",
    package_name: "ru.briginvest.sense",
  },
  {
    bankName: "МП Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000169.png",
    schema: "bank100000000169",
    package_name: "ru.ftc.faktura.multibank",
  },
  {
    bankName: "ГОРБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000125.png",
    schema: "bank100000000125",
    package_name: "com.isimplelab.ionic.gorbank.prod",
  },
  {
    bankName: "МОСКОМБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000176.png",
    schema: "bank100000000176",
    package_name: "ru.ftc.faktura.moscombank",
  },
  {
    bankName: "Тимер Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000144.png",
    schema: "bank100000000144",
    package_name: "com.timerbank.retail",
  },
  {
    bankName: "Автоторгбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000181.png",
    schema: "bank100000000181",
    package_name: "com.bifit.atbbank",
  },
  {
    bankName: "БАНК УРАЛСИБ",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000026.png",
    schema: "bank100000000026",
    package_name: "ru.bankuralsib.mb.android",
  },
  {
    bankName: "Ингосстрах Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000078.png",
    schema: "bank100000000078",
    package_name: "com.banksoyuz.artsofte",
    isDrActive: true,
  },
  {
    bankName: "Русьуниверсалбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000165.png",
    schema: "bank100000000165",
    package_name: "ru.rubank.ubsmobile",
  },
  {
    bankName: "КБ УБРиР",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000031.png",
    schema: "bank100000000031",
    package_name: "cb.ibank",
  },
  {
    bankName: "АКБ Приморье",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000226.png",
    schema: "bank100000000226",
    package_name: "ru.ftc.faktura.multibank",
  },
  {
    bankName: "Банк ИПБ",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000236.png",
    schema: "bank100000000236",
    package_name: "ru.ipb.ubsmobile",
    webClientUrl: "https://on-line.ipb.ru/sbp",
    isWebClientActive: "true",
  },
  {
    bankName: "КБ Пойдём!",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000103.png",
    schema: "bank100000000103",
    package_name: "com.openwaygroup.ic.panda.poidem",
  },
  {
    bankName: "АКБ ТЕНДЕР-БАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000175.png",
    schema: "bank100000000175",
    package_name: "com.bifit.mobile.citizen.tenderbank",
  },
  {
    bankName: "ОТП Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000018.png",
    schema: "bank100000000018",
    package_name: "ru.otpbank.mobile",
  },
  {
    bankName: "КБ Крокус-Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000212.png",
    schema: "bank100000000212",
    package_name: "ru.krk.ubsmobile",
  },
  {
    bankName: "Ренессанс Банк (Ренессанс Кредит)",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000032.png",
    schema: "bank100000000032",
    package_name: "cz.bsc.rc",
  },
  {
    bankName: "УКБ Белгородсоцбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000225.png",
    schema: "bank100000000225",
    package_name: "com.bifit.mobile.citizen.belsocbank",
  },
  {
    bankName: "Хайс Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000272.png",
    schema: "bank100000000272",
    package_name: "com.hicebank.android",
  },
  {
    bankName: "Севергазбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000219.png",
    schema: "bank100000000219",
    package_name: "com.bpc.crossplatform_trading.bpc_trading",
  },
  {
    bankName: "АКБ НРБанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000184.png",
    schema: "bank100000000184",
    package_name: "com.bifit.nrb",
  },
  {
    bankName: "КБ Москоммерцбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000110.png",
    schema: "bank100000000110",
    package_name: "com.bifit.mobile.citizen.moskb",
  },
  {
    bankName: "Кубаньторгбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000180.png",
    schema: "bank100000000180",
    package_name: "ru.isfront.android.kt",
  },
  {
    bankName: "УКБ Новобанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000222.png",
    schema: "bank100000000222",
    package_name: "ru.ftc.faktura.novobank",
  },
  {
    bankName: "НК Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000233.png",
    schema: "bank100000000233",
    package_name: "com.bifit.mobile.citizen.nkbank",
    webClientUrl: "https://sbp.nkbank.ru/sbp/c2b",
    isWebClientActive: "true",
  },
  {
    bankName: "Тойота Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000138.png",
    schema: "bank100000000138",
    package_name: "com.isimplelab.ibank.toyota",
  },
  {
    bankName: "ББР Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000133.png",
    schema: "bank100000000133",
    package_name: "com.bifit.mobile.private.bbr",
  },
  {
    bankName: "АКБ Ланта-Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000245.png",
    schema: "bank100000000245",
    package_name: "ru.ftc.faktura.lanta",
    webClientUrl: "https://dbo.lanta.ru/fps/c2b",
    isWebClientActive: "true",
  },
  {
    bankName: "КБ Долинск",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000270.png",
    schema: "bank100000000270",
    package_name: "ru.ftc.faktura.dolinsk",
  },
  {
    bankName: "Банк Финсервис",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000216.png",
    schema: "bank100000000216",
    package_name: "com.finservice.mobile",
  },
  {
    bankName: "КБ ЮНИСТРИМ",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000042.png",
    schema: "bank100000000042",
    package_name: "com.ltech.unistream",
  },
  {
    bankName: "КБ Новый век",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000067.png",
    schema: "bank100000000067",
    package_name: "com.isimplelab.ionic.standart",
  },
  {
    bankName: "Банк МБА-МОСКВА",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000192.png",
    schema: "bank100000000192",
    package_name: "ru.ibam.retailmobile",
  },
  {
    bankName: "БКС Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000041.png",
    schema: "bank100000000041",
    package_name: "ru.bcs.bcsbank",
  },
  {
    bankName: "АКБ СЛАВИЯ",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000200.png",
    schema: "bank100000000200",
    package_name: "com.isimplelab.ionic.slavia.prod",
  },
  {
    bankName: "АКБ ЕВРОФИНАНС МОСНАРБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000167.png",
    schema: "bank100000000167",
    package_name: "com.bifit.mobile.citizen.efbank",
  },
  {
    bankName: "Яндекс",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000150.png",
    schema: "bank100000000150",
    package_name: "com.yandex.bank",
  },
  {
    bankName: "Банк БЖФ",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000260.png",
    schema: "bank100000000260",
    package_name: "ru.ftc.faktura.bgfbank",
  },
  {
    bankName: "КБ ЛОКО-Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000161.png",
    schema: "bank100000000161",
    package_name: "com.idamobile.android.LockoBank",
  },
  {
    bankName: "БАНК МОСКВА-СИТИ",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000234.png",
    schema: "bank100000000234",
    package_name: "com.bifit.mobile.citizen.MCBank",
  },
  {
    bankName: "Драйв Клик Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000250.png",
    schema: "bank100000000250",
    package_name: "com.cetelem.cetelem_android",
    webClientUrl: "https://online.driveclickbank.ru",
    isWebClientActive: "true",
  },
  {
    bankName: "ГУТА-БАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000149.png",
    schema: "bank100000000149",
    package_name: "com.bssys.gutaretail",
  },
  {
    bankName: "ФИНСТАР БАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000278.png",
    schema: "bank100000000278",
    package_name: "ru.ftc.faktura.siab",
  },
  {
    bankName: "банк Раунд",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000247.png",
    schema: "bank100000000247",
    package_name: "com.isimplelab.ionic.round.prod",
  },
  {
    bankName: "Прио-Внешторгбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000228.png",
    schema: "bank100000000228",
    package_name: "com.priobank.prio",
  },
  {
    bankName: "Инбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000196.png",
    schema: "bank100000000196",
    package_name: "com.inbank.mobilebank",
  },
  {
    bankName: "Уралфинанс",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000096.png",
    schema: "bank100000000096",
    package_name: "com.isimplelab.isimplemobile.payjet",
  },
  {
    bankName: "Банк Агророс",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000102.png",
    schema: "bank100000000102",
    package_name: "ru.ftc.faktura.agroros",
    webClientUrl: "https://my.agroros.ru/fps/c2b",
    isWebClientActive: "true",
  },
  {
    bankName: "ЮГ-Инвестбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000160.png",
    schema: "bank100000000160",
    package_name: "com.bifit.mobile.citizen.invb",
  },
  {
    bankName: "ЦентроКредит",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000231.png",
    schema: "bank100000000231",
    package_name: "com.compassplus.mobicash.customer",
  },
  {
    bankName: "Снежинский",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000163.png",
    schema: "bank100000000163",
    package_name: "com.compassplus.mobicash.customer",
  },
  {
    bankName: "Банк ФИНАМ",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000040.png",
    schema: "bank100000000040",
    package_name: "ru.finambank.app",
  },
  {
    bankName: "Банк Точка",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000284.png",
    schema: "bank100000000284",
    package_name: "",
    webClientUrl: "https://i.tochka.com/a/sbp_c2b",
    isWebClientActive: "true",
  },
  {
    bankName: "банк Элита",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000266.png",
    schema: "bank100000000266",
    package_name: "",
  },
  {
    bankName: "Металлинвестбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000046.png",
    schema: "bank100000000046",
    package_name: "",
  },
  {
    bankName: "ПроБанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000117.png",
    schema: "bank100000000117",
    webClientUrl: "https://bk.probank.pro/a567/",
    isWebClientActive: "true",
  },
  {
    bankName: "Цифра банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000265.png",
    schema: "bank100000000265",
    package_name: "",
  },
  {
    bankName: "Озон Банк (Ozon)",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000273.png",
    schema: "bank100000000273",
    package_name: "",
  },
  {
    bankName: "Первый Дортрансбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000137.png",
    schema: "bank100000000137",
    package_name: "",
  },
  {
    bankName: "ЦМРБанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000282.png",
    schema: "bank100000000282",
    package_name: "",
  },
  {
    bankName: "Плайт",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000296.png",
    schema: "bank100000000296",
    webClientUrl: "https://plait.ru/lk/qr",
    isWebClientActive: "true",
  },
  {
    bankName: "Банк Оранжевый",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000286.png",
    schema: "bank100000000286",
  },
  {
    bankName: "ИКБР ЯРИНТЕРБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000293.png",
    schema: "bank100000000293",
  },
  {
    bankName: "РНКО Платежный конструктор",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000288.png",
    schema: "bank100000000288",
  },
  {
    bankName: "Азиатско-Тихоокеанский Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000108.png",
    schema: "bank100000000108",
  },
  {
    bankName: "Вайлдберриз Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000259.png",
    schema: "bank100000000259",
  },
  {
    bankName: "Экономбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000198.png",
    schema: "bank100000000198",
  },
  {
    bankName: "Ставропольпромстройбанк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000267.png",
    schema: "bank100000000267",
  },
  {
    bankName: "НКО Мобильная карта",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000271.png",
    schema: "bank100000000271",
    webClientUrl: "https://wallet.1cupis.ru/qr",
    isWebClientActive: "true",
  },
  {
    bankName: "Филиал Открытие БМ-Банк",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000015.png",
    schema: "bank100000000015",
    package_name: "com.openbank",
    webClientUrl: "https://app.open.ru/paymentc2b",
    isWebClientActive: "true",
  },
  {
    bankName: "МТС Деньги (ЭКСИ Банк)",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000289.png",
    schema: "bank100000000289",
  },
  {
    bankName: "ЖИВАГО БАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000295.png",
    schema: "bank100000000295",
  },
  {
    bankName: "РОКЕТБАНК",
    logoURL: "https://qr.nspk.ru/proxyapp/logo/bank100000000301.png",
    schema: "bank100000000301",
  },
];

export const plusSumsForDeposits = [
  {
    currency: "RUB",
    amounts: [
      { text: "+500", value: 500 },
      { text: "+1000", value: 1000 },
      { text: "+2000", value: 2000 },
    ],
  },
  {
    currency: "EUR",
    amounts: [
      { text: "+5", value: 5 },
      { text: "+10", value: 10 },
      { text: "+50", value: 50 },
    ],
  },
  {
    currency: "USD",
    amounts: [
      { text: "+5", value: 5 },
      { text: "+10", value: 10 },
      { text: "+50", value: 50 },
    ],
  },
  {
    currency: "TRY",
    amounts: [
      { text: "+200", value: 200 },
      { text: "+400", value: 400 },
      { text: "+2000", value: 2000 },
    ],
  },
  {
    currency: "PLN",
    amounts: [
      { text: "+20", value: 20 },
      { text: "+40", value: 40 },
      { text: "+80", value: 80 },
    ],
  },
  {
    currency: "KZT",
    amounts: [
      { text: "+2000", value: 2000 },
      { text: "+5000", value: 5000 },
      { text: "+10000", value: 10000 },
    ],
  },
];
